import type {AskHealthWeek} from 'client';

/** A 0–1 share as a whole percent, or a dash when there's no data. */
export const percent = (value?: number | null) =>
  value == null ? '—' : `${Math.round(value * 100)}%`;

/** Seconds with one decimal under 20s, whole seconds above. */
export const seconds = (value?: number | null) => {
  if (value == null) {
    return '—';
  }
  return value < 20 ? `${value.toFixed(1)}s` : `${Math.round(value)}s`;
};

/** "Oct 26", or "Nov 2 (so far)" for the week in progress. Weeks start Monday UTC. */
export const weekLabel = (week: AskHealthWeek) => {
  const label = shortDate(week.start);
  return week.complete ? label : `${label} (so far)`;
};

/** "Oct 29", or "Oct 29 (today)" for the day in progress. Days are UTC. */
export const dayLabel = (day: AskHealthWeek) => {
  const label = shortDate(day.start);
  return day.complete ? label : `${label} (today)`;
};

/** "Jun 30" for a `YYYY-MM-DD` date, read as UTC. */
export const shortDate = (isoDate: string) =>
  new Date(`${isoDate}T00:00:00Z`).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC',
  });

export const errorsAndAbandoned = (week?: AskHealthWeek) =>
  week?.error == null || week.abandoned == null ? null : week.error + week.abandoned;

/** A 0–1 share as 0–100 for charting, keeping missing values missing. */
export const asPercent = (value?: number | null) => (value == null ? null : value * 100);
